import { GridLinkOperator } from '../../../models/gridFilterItem';
export const getDefaultGridFilterModel = () => ({
  items: [],
  linkOperator: GridLinkOperator.And,
  quickFilterValues: [],
  quickFilterLogicOperator: GridLinkOperator.And
});


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/features/filter/gridFilterState.js
// module id = 635
// module chunks = 25